import {OrderService, MovieService, RegionService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import MetaData from '../../../mixins/meta-data.js'

export default {

    mixins: [MetaData],

    data() {
        return {
            loading: true,
            order: null,
            movie: {},
            regions: null,
            session: undefined,
            stepType: "booking",
            stepNames: [
                {
                    step: 1,
                    text: 'Your Seats'
                },
                {
                    step: 2,
                    text: 'Your Extras'
                },
                {
                    step: 3,
                    text: 'Confirm Booking'
                },
                {
                    step: 4,
                    text: 'Checkout'
                }
            ],
            loadingContinue: false,
            cancelOrderLoad: false,
            showHandleGenericError: false,
        }
    },

    computed: {

        step() {

            return parseInt(this.$route.path.replace('/booking/', '').split('/')[0])
        },

        cinema() {
            return this.order && this.regions ? this.regions.findCimema(this.order.Session.CinemaId) : {};
        }
    },

    beforeRouteUpdate(to, from, next) {
        let fromIsConcessionStep = Boolean(~from.path.indexOf('booking/2'));
        let toIsSeatingStep = Boolean(~to.path.indexOf('booking/1'));
        if (fromIsConcessionStep && toIsSeatingStep) {
            if (this.order.modified) {
                this.loading = true;
                return OrderService.saveOrderConcessionsOnly().then((order) => {
                    this.loading = false;
                    return next()
                })
            } else return next();
        } else return next();
    },

    methods: {

        setOrder(eventKey, order) {
            this.order = order;
        },

        handleOrderError(error) {
            //handle order retrieval error here:
            //window.location.href = '/';
            this.showHandleGenericError = true;

            return Promise.reject(error);
        },

        getOrder() {
            OrderService.getOrder().then((order) => {
                this.order = order;
                OrderService.addObserver(this, OrderService.ORDER_CHANGED_EVENT, this.setOrder);
                RegionService.getRegions().then((regions) => this.regions = regions);
                this.loading = false
                this.isNouveau(order)
            }, this.handleOrderError)
        },

        isNouveau(order) {
            order.Session.MoviePromise.then(() => {
                order.Experiences.forEach((exp) => {
                    if (exp && exp.name.includes('Nouveau')) this.cinemaType = exp.name
                })
                if (this.cinemaType) {
                    this.$root.$el.classList.add('nouveau')
                    this.$parent.$refs['site-header'].logoSrc = '/static/img/nouveau-logo.png'
                } else {
                    this.$root.$el.classList.remove('nouveau')
                    this.$parent.$refs['site-header'].logoSrc = '/static/img/sk-logo.png'
                }
            })
        },

        setMetaData() {
            let currentURL = this.$route.path.replace('/booking/', '')
            this.stepNames.forEach((e) => {
                if (e.step === parseInt(currentURL.replace('/booking/', ''))) {
                    this.metaTitle = 'Booking Step ' + e.step
                }
            })
            this.$emit('updateHead');
        },

        backToMovie() {
            this.showTimeout = false
            this.loadingContinue = true
            OrderService.tearDown();
            this.showHandleGenericError = false
            this.$router.push("/details/" + this.movie.id)
        },

        goHome() {
            this.showTimeout = false
            this.cancelOrderLoad = true
            OrderService.tearDown();
            this.showHandleGenericError = false
            this.$router.push('/');
        },
    },

    created() {
        this.loading = true
        this.setMetaData()
        this.getOrder()
    },

    updated() {
        let overlay = document.querySelector('.overlay')
        if (overlay) overlay.remove()
        if (this.order) this.isNouveau(this.order)
        this.setMetaData()

    }
}


// WEBPACK FOOTER //
// ./src/components/pages/booking/booking.js